import { render, staticRenderFns } from "./news_detail.vue?vue&type=template&id=13df59b5&scoped=true"
import script from "./news_detail.vue?vue&type=script&lang=js"
export * from "./news_detail.vue?vue&type=script&lang=js"
import style0 from "./news_detail.vue?vue&type=style&index=0&id=13df59b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df59b5",
  null
  
)

export default component.exports